export default __webpack_public_path__ + "static/Nail4-84ba963a22dfcd6eb0815497d4aac481.png";